import { render, staticRenderFns } from "./RequisitesIcon.vue?vue&type=template&id=edc155de&"
import script from "./RequisitesIcon.vue?vue&type=script&lang=js&"
export * from "./RequisitesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports